import type {
  ProductDto,
  ProductListItemDto,
  CartProductListItemDto,
  OrderItemDto,
} from '@repo/api/web/models'

import type { EcommerceProduct } from '../models'

import { getEffectiveCatalogPrice } from '#Promotion/utils/promoPrice'

/**
 * Товар каталога/карточки/корзины → productFieldObject (ТЗ §5.4).
 * id — артикул (не числовой productId); price — финальная каталожная цена
 * (промо, если есть); brand в контракте витрины отсутствует
 */
type CatalogLike = ProductDto | ProductListItemDto | CartProductListItemDto

export function mapCatalogProduct(
  item: CatalogLike,
  extra?: { list?: string, position?: number, quantity?: number },
): EcommerceProduct {
  return pruneUndefined({
    id: item.wellKnownAttributes?.Article || String(item.id ?? ''),
    name: item.wellKnownAttributes?.Name || undefined,
    price: getEffectiveCatalogPrice(item),
    category: item.categories?.[0]?.displayName ?? undefined,
    list: extra?.list,
    position: extra?.position,
    quantity: extra?.quantity,
  })
}

/**
 * Позиция заказа → productFieldObject для purchase. price — финальная цена
 * единицы, зафиксированная при оформлении; quantity = число экземпляров
 * (в контракте нет отдельного поля количества); variant — из ключевых атрибутов
 */
export function mapOrderItem(item: OrderItemDto): EcommerceProduct {
  const variant = item.keyAttributes
    ?.map(attr => attr.value)
    .filter(Boolean)
    .join(' / ')

  return pruneUndefined({
    id: item.article || String(item.productId ?? ''),
    name: item.name || undefined,
    price: item.price,
    quantity: item.instances?.length || 1,
    variant: variant || undefined,
  })
}

function pruneUndefined(product: EcommerceProduct): EcommerceProduct {
  const result = {} as Record<string, unknown>
  for (const [key, value] of Object.entries(product)) {
    if (value !== undefined && value !== null && value !== '') {
      result[key] = value
    }
  }
  return result as unknown as EcommerceProduct
}
